module.exports = __webpack_public_path__ + "assets/img/f5da6011c9e4db5a1f2c4282bd2a30c0.svg";